
import { defineComponent, reactive, onMounted, computed } from "vue";
import { usePlugin } from "@/plugins";
import {
  Employee,
  TrainingAssessment,
  GetIndividualEmployeeRequest,
  GetIndividualEmployeeResponse,
  TrainingDocument,
  PositionDocument,
  DownloadEmployeeHistoryRequest,
} from "@/types";
import { saveAs } from "file-saver";

export default defineComponent({
  name: "EmployeeScreen",
  setup() {
    const {
      setLoading,
      axios,
      success,
      error,
      route,
      formatAppDate,
    } = usePlugin();

    const screen = reactive<{
      employee: Employee | null;
      documents: TrainingDocument[] | null;
      positions: PositionDocument[] | null;
      photo: string | null;
    }>({
      employee: null,
      documents: null,
      positions: null,
      photo: null,
    });

    const onDownloadExcel = async () => {
      if (screen.employee === null) {
        error("ไม่พบข้อมูลพนักงานไม่สามารถ download ได้");
        return;
      }
      setLoading(true);
      try {
        const result = await axios.post(
          "api/v1/services/employee/download",
          {
            employeeId: screen.employee.id,
          } as DownloadEmployeeHistoryRequest,
          { responseType: "blob" }
        );
        saveAs(result.data);
      } catch (e) {
        error(e);
      } finally {
        setLoading(false);
      }
    };

    const loadEmployee = async () => {
      setLoading(true);
      try {
        const result = await axios.post<GetIndividualEmployeeResponse>(
          "api/v1/services/employee",
          {
            id: route.params.id,
          } as GetIndividualEmployeeRequest
        );
        screen.employee = result.data.employee;
        screen.documents = result.data.trainingDocuments;
        screen.positions = result.data.positionDocuments;
        screen.photo = result.data.photo;
      } catch (e) {
        error(e);
      } finally {
        setLoading(false);
      }
    };

    onMounted(async () => {
      await loadEmployee();
    });
    return {
      formatAppDate,
      onDownloadExcel,
      screen,
    };
  },
});
